import {endpoint} from "@/utils/api/Conf";
import {WalkStatus} from "@/types/Walk";

export const pathStatusRequest = async (authToken: string, pathId: string): Promise<WalkStatus | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }
    const response = await fetch(endpoint + `walk/status/${pathId}`, init)
    if (!response.ok) {
      return false
    } else {
      return await response.json();
    }
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
}

